import { Link } from "react-router-dom";
import { Fish, Phone, Mail, Globe, MapPin, Instagram, Youtube, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#021B2F] text-white/85 pt-16 pb-8 mt-24 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: "radial-gradient(circle at 20% 30%, #00B4D8 0%, transparent 45%), radial-gradient(circle at 80% 70%, #0086C6 0%, transparent 45%)",
      }} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-10 border-b border-white/10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-xl bg-white grid place-items-center p-1.5">
                <img src="/assets/silaing/logo-jabar.png" alt="Logo Pemprov Jabar" className="w-full h-full object-contain" />
              </div>
              <div>
                <div className="font-heading font-bold text-xl">SILAING</div>
                <div className="text-[10px] uppercase tracking-widest text-[#48CAE4]">DKP Jawa Barat</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-white/70 mb-4">
              Sistem Informasi Laut dan Ikan Terintegrasi — portal resmi Dinas Kelautan dan Perikanan Provinsi Jawa Barat.
            </p>
            <div className="flex gap-2">
              <a href="https://www.instagram.com/dkp_jabar/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 grid place-items-center rounded-full bg-white/10 hover:bg-[#00B4D8] transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://www.youtube.com/@dkpjabar7133" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-9 h-9 grid place-items-center rounded-full bg-white/10 hover:bg-[#00B4D8] transition-colors">
                <Youtube className="w-4 h-4" />
              </a>
              <a href="https://x.com/dislutkan_jabar" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="w-9 h-9 grid place-items-center rounded-full bg-white/10 hover:bg-[#00B4D8] transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <div className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-widest">Bidang</div>
            <ul className="space-y-2 text-sm">
              <li><Link className="hover:text-[#48CAE4]" to="/bidang/pembudidayaan-ikan-pengolahan-pemasaran">Pembudidayaan, Pengolahan & Pemasaran</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/bidang/perikanan-tangkap">Perikanan Tangkap</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/bidang/kelautan">Kelautan</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/bidang/pengawasan-sumberdaya-kelautan-perikanan">Pengawasan Sumberdaya</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-widest">Informasi</div>
            <ul className="space-y-2 text-sm">
              <li><Link className="hover:text-[#48CAE4]" to="/informasi/berita">Berita</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/informasi/regulasi">Regulasi</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/informasi/galeri">Galeri</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/informasi/agenda">Agenda</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/statistik/pilahsar">Statistik PILAHSAR</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/statistik/tangkap">Statistik TANGKAP</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/statistik/kelautan">Statistik KELAUTAN</Link></li>
              <li><Link className="hover:text-[#48CAE4]" to="/kontak">Kontak</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-widest">Kontak</div>
            <ul className="space-y-3 text-sm text-white/75">
              <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#48CAE4] shrink-0" /><span>Jl. Wastukencana No.17, Babakan Ciamis, Sumur Bandung, Kota Bandung 40117</span></li>
              <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-[#48CAE4] shrink-0" /><span>(022) 4203471</span></li>
              <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-[#48CAE4] shrink-0" /><span>dkp@jabarprov.go.id</span></li>
              <li className="flex gap-3"><Globe className="w-4 h-4 mt-0.5 text-[#48CAE4] shrink-0" /><span>dkp.jabarprov.go.id</span></li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© 2025 Dinas Kelautan dan Perikanan Provinsi Jawa Barat. Hak Cipta Dilindungi.</div>
          <div className="font-accent tracking-wide">Sistem Informasi Laut dan Ikan Terintegrasi</div>
        </div>
      </div>
    </footer>
  );
}
